import BaseService from './baseService';
import router from '../routes/routes';

class Auth extends BaseService {
	async getUserData(opts = {}) {
		this.endPoint = '/me';

		return this.get(opts);
	}
	logIn(email, password) {
    this.endPoint = '/loginCashier';

		const user = {
			email: email,
			password: password
		};
		return this.post(user);
	}
	logInCustomer(email, password) {
    this.endPoint = '/users.login_mobile_external';

		const user = {
			email: email,
			password: password
		};
		return this.post(user);
	}
	loggedIn() {
		const authToken = window.localStorage.getItem('access_token');
		return typeof authToken === 'string' && authToken.length > 0;
	}
	logOut() {
		window.localStorage.clear();
		window.location.reload(true);
		router.push('/login');
	}
	getCategoryId(opts = {}){
		this.endPoint = '/submission-category-name/ORDER'
		return this.get(opts);
	}
	getProductCategoryId(opts = {}){
		this.endPoint = '/productsCategory'
		return this.get(opts);
	}
}

export default new Auth();